/* SAMPLE COLLECTORS */
// get COUNTRY
export const GET_COUNTRY_LIST = "GET_COUNTRY_LIST";
export const GET_COUNTRY_LIST_SUCCESS ="GET_COUNTRY_LIST_SUCCESS";
export const GET_COUNTRY_LIST_FAIL = "GET_COUNTRY_LIST_FAIL";
// Add COUNTRY
export const ADD_NEW_COUNTRY = "ADD_NEW_COUNTRY";
export const ADD_NEW_COUNTRY_SUCCESS = "ADD_NEW_COUNTRY_SUCCESS";
export const ADD_NEW_COUNTRY_FAIL = "ADD_NEW_COUNTRY_FAIL";
//Update COUNTRY
export const UPDATE_COUNTRY = "UPDATE_COUNTRY";
export const UPDATE_COUNTRY_SUCCESS = "UPDATE_COUNTRY_SUCCESS";
export const UPDATE_COUNTRY_FAIL = "UPDATE_COUNTRY_FAIL";


